module.exports = __webpack_public_path__ + "media/images/talent/fukidashi-02-b3c435ba53fb32b1bf50848c218ebcc1.png";